export default "__VITE_PUBLIC_ASSET__a2cc7c77__"